var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"c-footer"},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"c-footer__link"},[_c('a',{attrs:{"href":"https://thewebbird.me"}},[_vm._v("(c) thewebbird")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }